import React from 'react';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';

type Props = {
  path: string;
  title: string;
  children: React.ReactNode;
};

const Page = ({ path, title, children }: Props) => {
  return (
    <Route exact path={path}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </Route>
  );
};

export default Page;
